import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import CitiesListComponent from '../components/CitiesListComponent';
import HeaderComponent from '../components/HeaderComponent';

class CitiesListPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <CitiesListComponent location={this.props.location}/>
            </div>
        );
    }
}

export default CitiesListPage;